import type { ReactElement } from "react";

/**
 * Non-secret correlation reference for support conversations (FR-015).
 * Rendered on support/terminal surfaces where the contract supplies a
 * correlation ID; never displays any other outcome detail. FR-048 (006-6,
 * DECIDED 2026-09-04): surfaces presenting different correlation
 * identifiers label them distinctly ("Registration reference" vs "Payment
 * reference") via the label prop instead of the ambiguous shared default.
 */
export function SupportReference({
  correlationId,
  label = "Support reference",
}: {
  correlationId?: string;
  label?: string;
}): ReactElement | null {
  if (!correlationId) {
    return null;
  }
  // The correlation ID is explicitly non-secret and safe to display/copy.
  return (
    <p className="mt-4 text-sm text-gray-600">
      {label}: <span className="font-medium text-gray-900">{correlationId}</span>
    </p>
  );
}
